import { Helmet } from "react-helmet";
import {
    Box,
    Divider,
    InputAdornment,
    TextField,
    Container,
    Grid,
    Typography,
    Button,
    Paper
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect } from "react";
import { DropResult } from 'react-beautiful-dnd';
import DraggableListProgress from '../DraggableListProgress';
import cssVariables from "../../../../theme/cssVariables";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { useSelector, useDispatch } from "react-redux";
import { listGoalProgress } from "../../../../actions/admin";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import adminService from "../../../../services/admin.service";
import MessageDialog from "../../../../components/inbox/MessageDialog";

const useStyles = makeStyles({
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    toggleBtnRoot: {
        background: `transparent !important`,
        color: "#6B6B6B !important",
        width: "320px",
        border: "none !important",
    },
    toggleBtnSelected: {
        background: `${cssVariables.color.primary}!important`,
        color: "#fff!important",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        "
    },
    tab: {
        fontSize: "16px !important",
        fontWeight: "300 !important",
        // color: "#A3A3A3 !important",
        '&.Mui-selected': {
            color: cssVariables.color.primary + " !important"
        }
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap'
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const GoalProgress = () => {
    let { serial } = useParams()
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [search, setSearchValue] = React.useState("");
    const [title, setTitle] = React.useState("");
    const [allow_adjust, setAllow_adjust] = React.useState(true);
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    // const admin = useSelector((state) => state.Admin.listGoalProgress);
    const delItem = useSelector((state) => state.Admin.delItem);
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };

    useEffect(() => {
        dataSerachs()
    }, [search]);

    useEffect(() => {
        getListData()
    }, []);

    useEffect(() => {
        handleConfirmDeleteList()
    }, [delItem]);

    // useEffect(() => {
    //     let data = admin?.data?.goal_progress_data
    //     setTitle(admin?.data?.goal_progress_group?.name)
    //     setMainItems(data)
    //     dataSerachs(data !== undefined ? data : [])
    // }, [admin]);

    const getListData = () => {
        dispatch(listGoalProgress(serial)).then(resp => {
            let data = resp?.data?.goal_progress_data
            setTitle(resp?.data?.goal_progress_group?.name)
            setMainItems(data)
            dataSerachs(data !== undefined ? data : [])
        })
    }
    const dataSerachs = async (data) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data !== undefined && data !== null ? data : mainItems))
        if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'options') {
                        let checkName = false;
                        if (rs[key].name_en !== undefined && rs[key].name_en.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        if (rs[key].name_th !== undefined && rs[key].name_th.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        return checkName;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        await setItems(result);
    };
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const handleConfirmDeleteList = () => {
        if (delItem !== "" && delItem !== undefined && delItem !== null) {
            adminService.deleteGoalProgress(delItem).then(
                (response) => {
                    dispatch({
                        type: "SET_DELECT_PROGRESS",
                        payload: "",
                    });
                    getListData()
                    openSuccessDeleteDialog(true)
                },
            ).catch(() => {
                dispatch({
                    type: "SET_DELECT_PROGRESS",
                    payload: "",
                });
                handleOpenFailedMessageDialog()
            })
        }
    };
    const onDragEnd = ({ destination, source }: DropResult) => {
        // dropped outside the list
        let newData = []
        const newItems = reorder(mainItems, source.index, destination?.index, items);
        for (let index = 0; index <= newItems.length - 1; index++) {
            newItems[index].seq = index + 1
            if (source.index > destination?.index) {
                if (source.index >= index && destination?.index <= index) {
                    newData.push({ serial: newItems[index].serial, seq: index + 1 });
                }
            }
            if (source.index < destination?.index) {
                if (destination?.index >= index && source.index <= index) {
                    newData.push({ serial: newItems[index].serial, seq: index + 1 });
                }
            }
        }
        if (newData.length > 0) {
            adminService.updateGoalsProgress({ item: newData, options: { goal_progress_group_id: serial } }).then((rs) => {
                getListData()
            }).catch((err) => {

            })
        }
        // setMainItems(newItems);
        // dataSerachs(newItems)
    };

    const reorder = (items, startIndex, endIndex, filterData) => {
        const result = items;
        if (endIndex === undefined || endIndex === null) return result;
        let start = filterData[startIndex].seq - 1
        let end = filterData[endIndex === 0 ? 1 : endIndex === items.length - 1 ? items.length - 2 : endIndex].seq - 1
        const [removed] = result.splice(start, 1);
        result.splice(end, 0, removed);
        return result;
    };
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    console.log(serial, 99);

    return (
        <Box style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/goal-component')}>{t('admin.label.goalComponent')}</span> / <span style={styles.end} >{t('admin.label.goalProgressGroup')}</span> / <span style={styles.end} >{title}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item >
                            <Box sx={{ width: "100%" }}>
                                <Box pb="30px" pt="7px" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                    <Typography variant="h2" color="#404349" fontSize={28} lineHeight="30.8px" >
                                        {title}
                                    </Typography>
                                    <Box>
                                        <TextField
                                            id="input-with-icon-textfield"
                                            fullWidth
                                            placeholder={t('admin.label.searchName')}
                                            size="small"
                                            sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" } }}
                                            className="searchTextField-h40"
                                            value={search}
                                            onChange={handleSearch}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search style={{ color: "#C4C4C4" }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        <Button
                                            size="small"
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            onClick={() => clickLink(`/admin/goal-progress/create/${serial}`)}
                                            color="primary"
                                            disabled={allow_adjust === true ? false : true}
                                            variant="contained"
                                            sx={{ width: "103px", height: "45px", p: "0", textTransform: "none", "margin-left": "30px" }}
                                        >
                                            <PlusIcon className={classes.plusSvg} />
                                            <Typography ml={1}>{t("label.add")}</Typography>
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                            <div className={classes.root}>
                                <Paper className={classes.flexPaper}>
                                    <Box
                                        px="40px"
                                    >
                                        <Box
                                            px="25px"
                                            py="19px"
                                            sx={{ display: "flex", "flex-direction": "row" }}
                                        >
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "100px" }} pr="25px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('label.default')}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(20% - 40px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('label.iconEN')}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(20% - 40px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('label.iconTH')}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(26% - 40px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('label.name')}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(17% - 40px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.label.createdBy')}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(17% - 40px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.label.updatedBy')}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "100px" }}>
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {t('admin.label.action')}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider width="100%" />
                                    </Box>
                                    <DraggableListProgress serial={serial} adjust={allow_adjust} items={items} search={search} onDragEnd={onDragEnd} link={`/admin/goal-progress/edit/${serial}/`} />
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessDeleteDialogOpen}
                        setValue={openSuccessDeleteDialog}
                        text={t(`admin.label.GoalProgressDeletedSuccessfully`)}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={t(`admin.label.GoalProgressDeletedFail`)}
                    />
                </Container>
            </Box>
        </Box>
    );
};
export default GoalProgress;
